import * as types from '../types'
import moment from 'moment'
import update from 'immutability-helper'

import {
    VIEW_MODE,
    EDIT_MODE,
    STATUS_MAP,
    STATUS_SAVED,
} from '@Utils/constants';

export const initialSurveyState = {
    survey: [],
    response: [],
}

const defaultState = {
    reducerVariable: 'Character Reference Survey',
    mode: VIEW_MODE,
    loading: true,
    hasLoadedData: false,
    isClosed: false,
    appID: 0,
    dateSubmitted: undefined,
    dateModified: undefined,
    surveyData: {
        ...initialSurveyState
    },
    alert: {
        show: false,
        title: 'Survey Submitted',
        content: 'Successfuly submitted response.',
        confirmLabel: 'Ok',
        onHide: () => { },
    },
    confirmModal: {
        show: false,
        title: 'Submit Survey?',
        message: 'Do you want to submit this survey? you can still resubmit your response after submission.',
        confirmData: null, // Set the data to be passed in confirm
        onConfirm: () => { },
        onClose: () => { },
    },
    surveyFormAfterSubmitModal: {
        show: false
    }
}

// Define how the states will change based on the dispatched action

export default function surveyReducer(state = defaultState, action) {
    switch (action.type) {
        case types.LOAD_SURVEY:
            return update(state, {
                surveyData: {
                    survey: { $set: action.payload },
                }
            })
        case types.PREPARE_RESPONSE:
            return update (state, {
                surveyData: {
                    response: { $set: action.payload },
                }
            })
        case types.UPDATE_RESPONSE:
            return update (state, {
                surveyData: {
                    response: { [action.payload.index]: {
                        response: { $set: action.payload.value }
                    } },
                }
            })
        case types.HAS_DETAIL_LOADED:
                return update(state, {
                    hasLoadedData: { $set: action.payload }
                })
        case types.SET_APP_IDD:
                return update(state, {
                    appID: { $set: action.payload }
                }) 
        case types.UPDATE_IS_CLOSED:
                return update(state, {
                    isClosed: { $set: action.payload }
                }) 
        case types.UPDATE_SUBMITTED_DATE:
                return update(state, {
                    dateSubmitted: { $set: action.payload }
                }) 
        case types.UPDATE_MODIFIED_DATE:
                return update(state, {
                    dateModified: { $set: action.payload }
                }) 
        case types.SHOW_ALERT: 
            return update(state, {
                alert: { 
                    show: { $set: action.payload },
                }
            })
            case types.SHOW_CONFIRM_MODAL: 
            return update(state, {
                confirmModal: { 
                    show: { $set: action.payload }
                }
            })
            case types.UPDATE_CONFIRM_MODAL:
                return update(state, {
                    confirmModal: { $set: action.payload }
                })
            case types.SHOW_SURVEY_FORM_AFTER_SUBMIT_MODAL:
                return update(state, {
                    surveyFormAfterSubmitModal: {
                        show: { $set: action.payload }
                    }
                })
        default: return state
    }
}
